import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import styled from 'styled-components';

import Banner from '~/src/components/Banner';
import { breakPoints } from '~/src/constants/breakpoints';

export const BannerRouter = styled(Banner)`
    margin-bottom: 30px;
`;

export const GridContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: start;
    gap: 24px;
`;

export const Wrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
`;

export const RouterListTitle = styled.h2`
    ${FONTS.H1};
    margin-bottom: 60px;
    width: 100%;
    @media (max-width: 1400px) {
        margin-bottom: 50px;
    }
    @media (max-width: 1100px) {
        ${FONTS.H2};
    }
    @media (max-width: 900px) {
        ${FONTS.H3};
    }
    @media (max-width: 500px) {
        margin-bottom: 30px;
        ${FONTS.H4};
    }
`;

export const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 1360px;
    ${FONTS.S};
    justify-content: flex-start;
    align-items: baseline;
    padding: 0 105px;
    box-sizing: content-box;
    @media (max-width: 1024px) {
        padding: 0 50px;
    }
    @media (max-width: 860px) {
        padding: 0 15px 0;
    }
    @media (max-width: 640px) {
        justify-content: flex-start;
        text-align: left;
    }
`;

export const RouterListContainer = styled.div`
    width: 100%;
    justify-content: center;
`;

export const InfoContainer = styled.div`
    align-items: center;
    margin-top: 100px;
`;

export const Title = styled.h1`
    ${FONTS.H1};
    max-width: 1360px;
    margin: 0;
    width: 100%;
    margin-top: 50px;
    margin-bottom: 20px;
    
    @media (max-width: 1024px) {
        margin-left: 50px;
    }
    @media (max-width: 860px) {
        margin-left: 15px;
        ${FONTS.H2};
        margin-top: ${props => props.auth ? '100px' : '60px'}
    }
`;

export const QuizSection = styled.div`
    display: block;
    width: 100%;
    padding-top: 30px;
    
    @media screen and (max-width: 859px) {
        margin-top: 60px;
    }
`;

export const PopupHeader = styled.div`
    background: linear-gradient(205.3deg, #FCFDFF 0%, #E9EAEF 100%);
    padding: 30px 50px;
    width: 100%;
    display: flex;
    flex-direction: column;
    border-radius: ${BorderRadius.OuterBlockRadius} ${BorderRadius.OuterBlockRadius} 0 0;

    @media screen and (max-width: 768px) {
        padding: 24px;
    }
`;

export const PopupBody = styled.div`
    padding: 40px 50px;
    width: 100%;
    display: flex;
    flex-direction: column;

    @media screen and (max-width: 768px) {
        padding: 24px;
    }
`;

export const PopupEquip = styled.div`
    ${FONTS.S};
`;

export const PopupTitle = styled.div`
    ${FONTS.L};
`;

export const OrderLine = styled.div`
    ${FONTS.L};
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #EBEBEB;
    padding-bottom: 30px;
    align-items: baseline;

    @media screen and (max-width: 768px) {
        ${FONTS.XS};
        padding-bottom: 14px;
    }
`;

export const OrderPrice = styled.div`
    ${FONTS.L};
    display: flex;
    align-items: baseline;
`;

export const Price = styled.div`
    @media (max-width: ${breakPoints.mobile}) {
        ${FONTS.XS};
    }
`;

export const OrderPriceInfo = styled.div`
    ${FONTS.XS};
    padding: 3px 0 0 5px;
`;

export const FormTitle = styled.div`
    ${FONTS.S};
    margin: 30px 0;

    @media screen and (max-width: 768px) {
        ${FONTS.XXS};
        margin: 12px 0;
    }
`;

export const PopupContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: baseline;
`;

export const Popup = styled(DefaultPopup)`
    z-index: 100;
`;
